import { computed, ref, Ref } from 'vue';
import { ComplexModal } from '@studyportals/modal';
import { IPresentableEntity } from '@/models/available-entities.interface';
import campaignPresenter from '@/presenters/campaign-presenter';
import * as Ladda from 'ladda';
import store from '@/store';

export default class UnlinkOrganisationWarningModalCode {
	public modalContent: Ref<HTMLElement | null> = ref(null);
	public proceedButton: Ref<HTMLButtonElement | null> = ref(null);
	private modal: Ref<ComplexModal | undefined> = ref(undefined);

	public isSaveEnabled = computed((): boolean => {
		return store.getters.isSaveEnabled();
	});

	public entitiesAffectedByUnlinking = computed((): IPresentableEntity[] => {
		return store.getters.entitiesAffectedByUnlinking();
	});

	public mounted(): void {
		this.prepareModal();
	}

	public unmounted(): void {
		window.ModalManager.close(this.modal.value);
	}

	public closeModal(): void {
		store.mutations.setEntitiesAffectedByUnlinking([]);
	}

	public async proceed(): Promise<void> {
		this.triggerLoadingAnimation();

		await campaignPresenter.saveCampaignDetails();

		this.closeModal();
	}

	private prepareModal(): void {
		if (!this.modalContent.value) {
			return;
		}

		this.modal.value = new ComplexModal(this.modalContent.value, {
			cssClassName: 'UnlinkOrganisationWarningModalWrapper',
			destroyOnClose: true,
			onClose: this.closeModal.bind(this)
		});

		window.ModalManager.open(this.modal.value);
	}

	private triggerLoadingAnimation(): void {
		if (!this.proceedButton.value) {
			return;
		}

		Ladda.create(this.proceedButton.value).start();
	}
}
